import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { ProductsComponent } from './products.component';

@NgModule({
  declarations: [
    ProductsComponent
  ],
  imports:[BrowserModule],
  exports:[ProductsComponent],
  providers: [],
})
export class ProductsModule { }



// WEBPACK FOOTER //
// ./src/app/products/products.module.ts